var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgMagnifyingGlass = function SvgMagnifyingGlass(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "transparent",
    d: "M0 0h48v48H0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "nonzero",
    d: "M39.2 42 26.6 29.4c-1 .8-2.15 1.433-3.45 1.9-1.3.467-2.683.7-4.15.7-3.633 0-6.708-1.258-9.224-3.774C7.259 25.709 6 22.633 6 19c0-3.633 1.259-6.709 3.776-9.226C12.292 7.258 15.366 6 19 6c3.633 0 6.709 1.258 9.226 3.774C30.742 12.291 32 15.367 32 19c0 1.467-.233 2.85-.7 4.15-.467 1.3-1.1 2.45-1.9 3.45L42 39.2zM19 28c2.5 0 4.625-.875 6.376-2.624C27.126 23.626 28 21.5 28 19c0-2.5-.875-4.625-2.624-6.376C23.626 10.874 21.5 10 19 10c-2.5 0-4.625.875-6.376 2.624C10.874 14.374 10 16.5 10 19c0 2.5.875 4.625 2.624 6.376C14.374 27.126 16.5 28 19 28"
  }))));
};
export default SvgMagnifyingGlass;